import { Component } from "react";
import footerLogo from '../../../images/logoBranca.png';

export default class FooterHotsite extends Component {
    render() {
        return <>
            <div className="h-footer">
                <footer className="h-footer-container">
                    <section>
                        <div>
                            <a href="/#sobre">Sobre</a>
                            <a href="/#funcionalidades">Funcionalidades</a>
                            <a href="/#depoimentos">Depoimentos</a>
                            <a href="/#perguntas-frequentes">Perguntas frequentes</a>
                        </div>
                        <div>
                            <a href="/politica_de_privacidade" onClick={pEvento => { pEvento.preventDefault(); window.location.href = "/hotsite/politica_de_privacidade" }}>Política de privacidade</a>
                            <a href="/termos_de_uso" onClick={pEvento => { pEvento.preventDefault(); window.location.href = "/hotsite/termos_de_uso" }}>Termos de uso</a>
                        </div>
                        <div>
                            {/* <a href="/" target="_blank" rel="noreferrer">Facebook</a> */}
                            <a href="https://www.instagram.com/rapidafaxina/?igshid=YmMyMTA2M2Y%3D" target="_blank" rel="noreferrer">Instagram</a>
                        </div>
                    </section>
                    <img src={footerLogo} alt="logo rodapé" />
                </footer>
            </div>
        </>
    }
}